'use strict';

function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
    $scope.global = Global;

    let model = this;
    model.settings = settings;
    model.lineChartIdentifiers = {
        key: false,
        id: false
    };
    model.tableIdentifiers = {
        key: false,
        id: false
    };

    socketIo('/api/general_network/inbound_orig').then(function(socket) {
        /////////////
        /// TABLE ///
        /////////////

        // register data object
        $scope.main.registerVisual({
                // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
                refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
                searchable: true, // optional search param.. no if undefined
                get: {
                    call: 'table',
                    socket: socket
                },
                grouping: [
                    'sensor',
                    'orig_ip'
                ],
                sort: {
                    direction: '-', // '-' == desc, '+' == asc
                    col: 'time'
                },
                title: 'Inbound Origin / Responder Traffic',
                columns: [{
                    title: 'Last Seen',
                    select: 'time',
                    dView: true,
                    link: {
                        type: 'search',
                        table_name: 'conn',
                        val: [
                            'orig_ip',
                            'resp_hostname',
                            'resp_ip'
                        ],
                        crumb: false
                    }
                }, {
                    title: 'Sensor',
                    select: 'sensor',
                    dView: true
                }, {
                    title: 'Vector',
                    select: 'vector',
                    dView: true
                }, {
                    title: 'Connections',
                    select: 'count',
                    dView: true
                }, {
                    title: 'Origin Local',
                    select: 'orig_local',
                    dView: false
                }, {
                    title: 'Origin IP',
                    select: 'orig_ip',
                    dView: true
                }, {
                    title: 'Origin Country',
                    select: 'orig_country',
                    dView: true
                }, {
                    title: 'Origin Flag',
                    select: 'orig_cc',
                    dView: true
                }, {
                    title: 'Origin ASN',
                    select: 'orig_asn_name',
                    dView: true
                }, {
                    title: 'Responder Local',
                    select: 'resp_local',
                    dView: false
                }, {
                    title: 'Responder IP',
                    select: 'resp_ip',
                    dView: true
                }, {
                    title: 'Responder Hostname',
                    select: 'resp_hostname',
                    dView: true
                }, {
                    title: 'Responder User',
                    select: 'resp_user',
                    dView: true
                }, {
                    title: 'Responder Stealth',
                    select: 'resp_stealth',
                    dView: true
                }, {
                    title: 'IOC Count',
                    select: 'ioc_count',
                    dView: true
                }, {
                    title: 'Blocked by Proxy',
                    select: 'proxy_blocked',
                    dView: true
                }, {
                    title: 'Payload Ratio',
                    select: 'breakdown',
                    dView: true
                }, {
                    title: 'Origin Payload',
                    select: 'bytes_orig',
                    dView: true
                }, {
                    title: 'Responder Payload',
                    select: 'bytes_resp',
                    dView: true
                }, ],
                searchCategories: {
                    'vector': 'Vector',
                    'sensor': 'Sensor',
                    'ioc_count' : "IOC Count",
                    'proxy_blocked': 'Blocked by Proxy',
                    'orig_local': 'Origin Local',
                    'orig_ip': 'Origin IP',
                    'orig_country': 'Origin Country',
                    'orig_cc': 'Origin Flag',
                    'orig_asn_name': 'Origin ASN',
                    'resp_local': 'Responder Local',
                    'resp_ip': 'Responder IP',
                    'resp_hostname': 'Responder Hostname',
                    'resp_user': 'Responder User',
                    'resp_stealth': 'Responder Stealth',
                }
            })
            // fetch the data when the object is registered
            .then(function(result) {
                model.tableIdentifiers = {
                        id: result.id,
                        key: result.key
                    }
                    // initalize table with column information so it can compile the directive
                $scope.$broadcast('table-build', model.tableIdentifiers);

                let time = angular.copy($scope.main.getTime());
                model.loadStart = time.end
                model.loadEnd = time.end
                    // return promise to build dimensions and groups for table
                return new fetchStream(result.settings.get.call, result.settings.get.socket);
            })
            .then(function(result) {
                model.complete = true;
                // stop the table spinner as soon as the resolve comes in
                usSpinnerService.stop(model.tableIdentifiers.id);
            }, function(err) {

            }, function(result) {
                // add rows
                $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                    // with our first data return, we can build dimensions and groups for our data
                    $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function() {
                        // dont start the spinner if the table loads faster than building group dim
                        if (!model.complete) {
                            // start table spinner right before init, but after build
                            usSpinnerService.spin(model.tableIdentifiers.id);
                        }
                        // initalize rows
                        $scope.$broadcast('init', model.tableIdentifiers);
                        if (result.min) {
                            model.loadStart = result.min;
                        }
                    }, function(err) {
                        console.log('error')
                        console.log(err)
                    })
                } else {
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                    $scope.$broadcast('updatedData', model.tableIdentifiers.id);
                }
            })
        $scope.$on('$destroy', function() {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/general_network/inbound_orig.js
 **/